import { svgList } from "./svg";

let storeRouter = [
  {
    path: "/userList",
    name: "UserList",
    layout: "dashboard",
    isMenu: true,
    svg: svgList.userList,
    title: "用户管理",
    component: () => import("../views/userList/index.vue"),
  },
];

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute(route, parentLayout = "default") {
  route.meta = route.meta || {};
  route.meta.layout = route.layout || parentLayout;
  route.meta.title = route.title || "";
  if (route.children) {
    route.children = route.children.map((childRoute) =>
      addLayoutToRoute(childRoute, route.meta.layout)
    );
  }
  return route;
}

storeRouter = storeRouter.map((route) => addLayoutToRoute(route));

export default storeRouter;
